var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wishcard" }, [
    _vm.cards.length > 0
      ? _c(
          "div",
          { staticClass: "wishcard__selection" },
          [
            _c("tg-form-select", {
              staticClass: "wishcard__input-select",
              attrs: {
                name: "select-card",
                value: _vm.card ? _vm.card.id : null,
                items: _vm.selectCardOptions,
                "item-text": "name",
                "item-value": "id"
              },
              on: { input: _vm.onInput }
            }),
            _vm._v(" "),
            _c("tg-form-radio-group", {
              staticClass: "wishcard__input-radio-group",
              attrs: {
                name: "radio-card",
                value: _vm.card ? _vm.card.id : null,
                inline: true,
                choices: _vm.cards,
                "item-label": "name",
                "item-value": "id"
              },
              on: { input: _vm.onInput }
            }),
            _vm._v(" "),
            _c("input", {
              attrs: { type: "hidden", name: "card" },
              domProps: { value: _vm.card ? _vm.card.id : "" }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "wishcard__display" },
      [
        _vm.card && _vm.card.size === "small"
          ? _c("tg-wishcard-small", {
              attrs: { card: _vm.card, "card-text": _vm.cardText || "" }
            })
          : _vm.card
          ? _c("tg-wishcard-big", {
              attrs: {
                card: _vm.card,
                "card-text": _vm.cardText || "",
                siteThumbnail: _vm.siteThumbnail
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }